export default __webpack_public_path__ + "static/media/author-6.0a344aff.png";